<template>
  <div class="app-container">
    <el-form
      :inline="true"
      :model="searchForm"
      class="demo-form-inline"
      label-position="top"
      size="small"
    >
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item class="numberSearch" label="">
            <template slot="label">
              <el-select v-model="type1" :placeholder="$t('CenterForSorting.pleaseChoose')">
                <el-option :label="$t('CenterForSorting.scanNumber')" value="scanOrderNumberList" />
                <el-option
                  :label="$t('CenterForSorting.waybillNumber')"
                  value="waybillNumberList"
                />
              </el-select>
            </template>
            <InputTextareaCmp
              ref="inputTextareaRef"
              :max-length="2000"
              :min-rows="2"
              :val="listVal"
              @input="(_, val) => (listVal = val)"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('CenterForSorting.machine')">
            <el-select
              v-model="searchForm.machineCode"
              :placeholder="$t('CenterForSorting.pleaseChoose')"
              clearable
              @change="handleSearch"
            >
              <el-option
                v-for="item in machineList"
                :key="item.machineCode"
                :label="item.machineName + '(' + item.machineCode + ')'"
                :value="item.machineCode"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('CenterForSorting.chuteNo')">
            <el-input
              v-model="searchForm.chuteNumber"
              :placeholder="$t('CenterForSorting.multipleChutesInput')"
              :rows="1"
              clearable
              type="textarea"
              @blur="BlockNewNumber"
              @keydown.enter.native="BlockNewNumber"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$t('CenterForSorting.timeRange')">
            <el-date-picker
              v-model="searchForm.createTime"
              :default-time="['00:00:00', '23:59:59']"
              :end-placeholder="$t('CenterForSorting.endTime')"
              :picker-options="pickerOptions"
              :start-placeholder="$t('CenterForSorting.startTime')"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              @focus="pickDate = null"
            />
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <div style="margin-top: 28px">
            <el-button
              icon="el-icon-search" size="mini" type="primary"
              @click="handleSearch"
            >{{ $t('CenterForSorting.search') }}
            </el-button>
            <el-button icon="el-icon-refresh" size="mini" @click="resetSearch">{{ $t('CenterForSorting.reset') }}
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>

    <el-card>
      <div class="table-toolbar">
        <!--全部导出-->
        <el-button size="small" type="primary" @click="allExportOrder">{{ $t('collectionCenter.export') }}
        </el-button>
        <el-button
          v-permit:remove="'btn:sorting:sortingRecord:openMeasure'"
          size="mini"
          type="primary"
          @click="openMeasureDialog"
        >
          {{ $t('CenterForSorting.waybillDropMeasure') }}
        </el-button>
      </div>
      <el-table
        v-loading="listLoading"
        :data="tableData"
        border
        fit
        highlight-current-row
        style="width: 100%"
      >
        <el-table-column
          :label="$t('CenterForSorting.ind')"
          align="center"
          type="index"
          width="60"
        />
        <el-table-column
          :label="$t('CenterForSorting.scanNumber')"
          align="center"
          min-width="160"
          prop="scanOrderNumber"
        />
        <el-table-column
          :label="$t('CenterForSorting.waybillNumber')"
          align="center"
          min-width="160"
          prop="waybillNumber"
        />
        <el-table-column
          :label="$t('CenterForSorting.chuteNo')"
          align="center"
          prop="chuteNumber"
          width="150"
        >
          <template slot-scope="{ row }">
            <div v-if="row.chuteNumber">
              <el-tag
                v-for="(tag, index) in String(row.chuteNumber).split(',')"
                :key="index"
                size="mini"
                style="margin-right: 5px"
              >
                {{ tag }}
              </el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('CenterForSorting.machineCode')"
          align="center"
          prop="machineCode"
          width="120"
        />
        <el-table-column :label="$t('CenterForSorting.supplyTable')" align="center" width="180">
          <template slot-scope="{ row }">
            <span>{{ getSupplyTableLabel(row) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('CenterForSorting.personAccount')"
          align="center"
          prop="personAccount"
          width="180"
        />
        <el-table-column
          :label="$t('CenterForSorting.supplyTime')"
          align="center"
          prop="supplyTime"
          width="160"
        />
        <el-table-column
          :label="$t('CenterForSorting.matchRule')"
          align="center"
          min-width="120"
          prop="matchedRuleName"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            <el-button v-if="row.matchedRuleName" type="text" @click="handleViewConditions(row)">
              {{ row.matchedRuleName }}
            </el-button>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('CenterForSorting.weightWithUnit')"
          align="center"
          prop="weight"
          width="100"
        />
        <el-table-column
          :label="$t('CenterForSorting.createTime')"
          align="center"
          prop="createTime"
          width="160"
        />
      </el-table>

      <!-- 分页工具 -->
      <div class="pagination">
        <el-pagination
          :current-page.sync="listQuery.pageNumber"
          :page-size.sync="listQuery.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="margin: 10px 0"
          @current-change="fetchData"
          @size-change="fetchData"
        />
      </div>
    </el-card>

    <el-dialog
      :title="$t('CenterForSorting.waybillDropMeasure')"
      :visible.sync="measureDialogVisible"
      append-to-body
      width="900px"
    >
      <el-form
        :inline="true" :model="measureForm" label-position="top"
        size="small"
      >
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$t('CenterForSorting.machine')">
              <el-select
                v-model="measureForm.machineCode"
                :placeholder="$t('CenterForSorting.pleaseChoose')"
                clearable
              >
                <el-option
                  v-for="item in machineList"
                  :key="item.machineCode"
                  :label="item.machineName + '(' + item.machineCode + ')'"
                  :value="item.machineCode"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item class="numberSearch" label="">
              <template slot="label">
                <el-select v-model="measureType" :placeholder="$t('CenterForSorting.pleaseChoose')">
                  <el-option :label="$t('CenterForSorting.scanNumber')" value="scanNumberList" />
                  <el-option
                    :label="$t('CenterForSorting.waybillNumber')"
                    value="waybillNumberList"
                  />
                </el-select>
              </template>
              <InputTextareaCmp
                ref="measureInputTextareaRef"
                :max-length="2000"
                :min-rows="2"
                :val="measureListVal"
                @input="(_, val) => (measureListVal = val)"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <div style="margin-top: 28px">
              <el-button size="mini" type="primary" @click="handleMeasureSearch">
                {{ $t('CenterForSorting.search') }}
              </el-button>
              <el-button size="mini" @click="resetMeasureSearch">
                {{ $t('CenterForSorting.reset') }}
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <el-table
        v-loading="measureLoading"
        :data="measureResultList"
        :empty-text="$t('CenterForSorting.noData')"
        border
        fit
        highlight-current-row
        style="width: 100%"
      >
        <el-table-column
          :label="$t('CenterForSorting.requestNumber')"
          align="center"
          min-width="220"
          prop="requestNumber"
          show-overflow-tooltip
        />
        <el-table-column :label="$t('CenterForSorting.chuteNo')" align="center" min-width="220">
          <template slot-scope="{ row }">
            <div v-if="getMeasureChuteTags(row).length">
              <el-tag
                v-for="(tag, index) in getMeasureChuteTags(row)"
                :key="`${row.requestNumber || ''}-${tag}-${index}`"
                :class="{ 'clickable-tag': !!row.ruleId }"
                size="mini"
                style="margin-right: 5px"
                @click.native="row.ruleId && handleViewConditions({ ruleId: row.ruleId })"
              >
                {{ tag }}
              </el-tag>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="measureDialogVisible = false">{{
          $t('CenterForSorting.close')
        }}</el-button>
      </span>
    </el-dialog>

    <!-- 查看条件对话框 -->
    <rule-condition-detail
      :condition-configs="conditionConfigs"
      :rule-id="currentRuleId"
      :visible.sync="viewConditionsVisible"
    />
  </div>
</template>

<script>
import InputTextareaCmp from '@/views/finance/cmp/Query/InputTextareaCmp.vue';
import {
  getSortingRecordExport,
  getSortingRecordPage,
  measureSortingRecord
} from '@/api/sorting/record';
import { getAllMachineList } from '@/api/sorting/machine';
import { getConditionConfigList } from '@/api/sorting/rule';
import RuleConditionDetail from './components/RuleConditionDetail';
import { goResourceTaskList } from '@/utils/goExportList';

export default {
  name: 'SortingRecord',
  components: { RuleConditionDetail, InputTextareaCmp },
  data() {
    return {
      type1: 'scanOrderNumberList',
      listVal: '',
      tableData: [],
      total: 0,
      listLoading: true,
      listQuery: {
        pageNumber: 1,
        pageSize: 10
      },
      searchForm: {
        scanOrderNumber: '',
        waybillNumber: '',
        machineCode: '',
        chuteNumber: '',
        chuteNumberList: [],
        sortingStatus: null,
        createTime: this.getDefaultTimeRange()
      },
      machineList: [],
      conditionConfigs: [],
      viewConditionsVisible: false,
      currentRuleId: null,
      measureDialogVisible: false,
      measureLoading: false,
      measureType: 'waybillNumberList',
      measureListVal: '',
      measureForm: {
        machineCode: ''
      },
      measureResultList: [],
      pickDate: null,
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.pickDate = minDate;
          if (maxDate) {
            this.pickDate = null;
          }
        },
        disabledDate: (time) => {
          if (this.pickDate) {
            const oneDay = 24 * 3600 * 1000;
            const minTime = this.pickDate.getTime() - 6 * oneDay;
            const maxTime = this.pickDate.getTime() + 6 * oneDay;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
          return false;
        }
      }
    };
  },
  created() {
    this.fetchMachines();
    this.fetchConditionConfigs();
    this.fetchData();
  },
  methods: {
    BlockNewNumber() {
      this.$nextTick(() => {
        if (this.searchForm.chuteNumber) {
          const lines = this.searchForm.chuteNumber
            .split('\n')
            .filter((line) => line && line.trim())
            .map((line) => line.replace(/\s/g, '').trim());
          this.searchForm.chuteNumber = lines.join('\n');
          this.searchForm.chuteNumberList = lines;
        } else {
          this.searchForm.chuteNumberList = [];
        }
      });
    },
    getDefaultTimeRange() {
      const start = new Date();
      start.setHours(0, 0, 0, 0);
      const end = new Date();
      end.setHours(23, 59, 59, 999);

      const formatDate = (date) => {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        const h = String(date.getHours()).padStart(2, '0');
        const min = String(date.getMinutes()).padStart(2, '0');
        const s = String(date.getSeconds()).padStart(2, '0');
        return `${y}-${m}-${d} ${h}:${min}:${s}`;
      };

      return [formatDate(start), formatDate(end)];
    },
    async fetchMachines() {
      // 获取设备列表用于下拉选择
      const res = await getAllMachineList();
      this.machineList = res.data || [];
    },
    async fetchConditionConfigs() {
      const res = await getConditionConfigList();
      this.conditionConfigs = res.data || [];
    },
    handleViewConditions(row) {
      // 优先使用 matchedRuleId，如果没有则使用 ruleId
      const ruleId = row.matchedRuleId || row.ruleId;
      if (!ruleId) return;
      this.currentRuleId = ruleId;
      this.viewConditionsVisible = true;
    },
    fetchData() {
      // 校验时间范围不能为空
      if (!this.searchForm.createTime || this.searchForm.createTime.length !== 2) {
        this.$message.warning(this.$t('CenterForSorting.timeRangeRequired'));
        this.listLoading = false;
        return;
      }

      // 验证时间范围不超过7天
      if (this.searchForm.createTime && this.searchForm.createTime.length === 2) {
        const start = new Date(this.searchForm.createTime[0]).getTime();
        const end = new Date(this.searchForm.createTime[1]).getTime();
        const diff = end - start;
        const days = diff / (1000 * 60 * 60 * 24);
        if (days > 7) {
          this.$message.warning(this.$t('CenterForSorting.queryTimeLimit'));
          this.listLoading = false;
          return;
        }
      }

      this.listLoading = true;
      const params = {
        pageNumber: this.listQuery.pageNumber,
        pageSize: this.listQuery.pageSize,
        params: {
          machineCode: this.searchForm.machineCode || undefined,
          chuteNumberList: this.searchForm.chuteNumberList || [],
          sortingStatus: this.searchForm.sortingStatus,
          createTimeBegin: this.searchForm.createTime && this.searchForm.createTime[0],
          createTimeEnd: this.searchForm.createTime && this.searchForm.createTime[1]
        }
      };

      const inputVal = this.$refs.inputTextareaRef ? this.$refs.inputTextareaRef.getValue() : [];
      if (inputVal && inputVal.length > 0) {
        params.params[this.type1] = inputVal;
      }

      getSortingRecordPage(params)
        .then((response) => {
          this.tableData = response.data.records;
          this.total = response.data.total;
          this.listLoading = false;
        })
        .catch(() => {
          this.listLoading = false;
        });
    },
    handleSearch() {
      this.listQuery.pageNumber = 1;
      this.fetchData();
    },
    resetSearch() {
      this.type1 = 'scanOrderNumberList';
      this.listVal = '';
      this.searchForm = {
        machineCode: '',
        chuteNumber: '',
        chuteNumberList: [],
        sortingStatus: null,
        createTime: this.getDefaultTimeRange()
      };
      this.handleSearch();
    },
    openMeasureDialog() {
      // 打开测算弹窗时复用当前页已选设备，减少重复选择
      this.measureDialogVisible = true;
      this.resetMeasureSearch();
      this.measureForm.machineCode = this.searchForm.machineCode || '';
    },
    resetMeasureSearch() {
      // 重置测算弹窗查询条件和结果列表
      this.measureType = 'waybillNumberList';
      this.measureListVal = '';
      this.measureResultList = [];
      if (this.$refs.measureInputTextareaRef) {
        this.$refs.measureInputTextareaRef.clear();
      }
    },
    async handleMeasureSearch() {
      // 分拣机为必填项
      if (!this.measureForm.machineCode) {
        this.$message.warning(this.$t('CenterForSorting.measureMachineRequired'));
        return;
      }
      // 解析多行输入的单号列表（自动去重与去空）
      const requestNumberList = this.$refs.measureInputTextareaRef
        ? this.$refs.measureInputTextareaRef.getValue()
        : [];
      if (!requestNumberList.length) {
        this.$message.warning(this.$t('CenterForSorting.measureNumberRequired'));
        return;
      }
      const params = {
        machineCode: this.measureForm.machineCode,
        [this.measureType]: requestNumberList
      };
      // 批量调用测算接口并回填结果列表
      this.measureLoading = true;
      try {
        const response = await measureSortingRecord(params);
        this.measureResultList = Array.isArray(response.data) ? response.data : [];
      } finally {
        this.measureLoading = false;
      }
    },
    getMeasureChuteTags(row) {
      // 统一兼容字符串与数组格式的格口号，便于按Tag展示
      if (
        !row ||
        row.chuteNumber === undefined ||
        row.chuteNumber === null ||
        row.chuteNumber === ''
      ) {
        return [];
      }
      if (Array.isArray(row.chuteNumber)) {
        return row.chuteNumber.map((item) => String(item).trim()).filter(Boolean);
      }
      return String(row.chuteNumber)
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean);
    },
    getSupplyTableEnumValue(row) {
      const key = 'tableNumber';
      if (row && row[key] !== undefined && row[key] !== null && row[key] !== '') {
        return this.normalizeSupplyTableEnumValue(row[key]);
      }
      return '';
    },
    normalizeSupplyTableEnumValue(value) {
      const rawValue = String(value).trim();
      if (!rawValue) {
        return '';
      }
      const matched = rawValue.match(/(\d{1,2})$/);
      if (!matched) {
        return rawValue;
      }
      const normalizedNumber = Number(matched[1]);
      if (!Number.isInteger(normalizedNumber) || normalizedNumber < 1 || normalizedNumber > 24) {
        return rawValue;
      }
      return String(normalizedNumber);
    },
    getSupplyTableLabel(row) {
      const enumValue = this.getSupplyTableEnumValue(row);
      if (!enumValue) {
        return '-';
      }
      const machineCode = row && row.machineCode ? String(row.machineCode).trim() : '';
      const i18nKeys = machineCode ? [`CenterForSorting.${machineCode}${enumValue}`] : [enumValue];
      for (let i = 0; i < i18nKeys.length; i++) {
        const key = i18nKeys[i];
        const text = this.$t(key);
        if (text !== key) {
          return text;
        }
      }
      return enumValue;
    },
    // 导出
    allExportOrder() {
      // 校验时间范围不能为空
      if (!this.searchForm.createTime || this.searchForm.createTime.length !== 2) {
        this.$message.warning(this.$t('CenterForSorting.timeRangeRequired'));
        return;
      }
      // 验证时间范围不超过7天
      if (this.searchForm.createTime && this.searchForm.createTime.length === 2) {
        const start = new Date(this.searchForm.createTime[0]).getTime();
        const end = new Date(this.searchForm.createTime[1]).getTime();
        const diff = end - start;
        const days = diff / (1000 * 60 * 60 * 24);
        if (days > 7) {
          this.$message.warning(this.$t('CenterForSorting.queryTimeLimit'));
          return;
        }
      }
      const params = {
        machineCode: this.searchForm.machineCode || undefined,
        chuteNumberList: this.searchForm.chuteNumberList || [],
        sortingStatus: this.searchForm.sortingStatus,
        createTimeBegin: this.searchForm.createTime && this.searchForm.createTime[0],
        createTimeEnd: this.searchForm.createTime && this.searchForm.createTime[1]
      };
      const inputVal = this.$refs.inputTextareaRef ? this.$refs.inputTextareaRef.getValue() : [];
      if (inputVal && inputVal.length > 0) {
        params[this.type1] = inputVal;
      }
      getSortingRecordExport(params).then((res) => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    }
  }
};
</script>

<style scoped>
.numberSearch ::v-deep .el-input--small .el-input__inner {
  line-height: 28px;
  height: 28px;
  border: none;
  padding-left: 0;
  font-weight: bold;
}

.table-toolbar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
}

.clickable-tag {
  cursor: pointer;
}
</style>
